import { render, staticRenderFns } from "./PlacementsEndComponentCapabilities.vue?vue&type=template&id=5d3f551b&"
import script from "./PlacementsEndComponentCapabilities.vue?vue&type=script&lang=js&"
export * from "./PlacementsEndComponentCapabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports